<template>
  <template v-if="mode === 'edit'">
    <div
      :class="[
        'py-2 unit-field relative',
        field.error ? 'my-2 px-2 rounded border-2 border-brand-red bg-brand-red bg-opacity-10' : ''
      ]"
      :name="field.name"
      :field-id="field.field_id"
      :required="field.required"
    >
      <!-- alert container -->
      <label for="input" class="block">
        {{ field.label }}
        <span v-if="field.required" class="text-brand-red">*</span>
      </label>
      <MultiLineInput
        :placeholder="`Street address,\nCity, State, Zip`"
        :value="field.value"
        @input="updateValue"
        :required="field.required"
        ref="input"
      ></MultiLineInput>
      <template v-if="field.help_text">
        <p class="text-brand-mid-gray italic text-xs">{{ field.help_text }}</p>
      </template>
      <template v-if="field.error">
        <p class="text-brand-red py-1">{{ errorMessage }}</p>
      </template>
      <div
        class="absolute border border-brand-mid-gray rounded-sm bg-white flex flex-col top-28 w-4/5 md:w-1/2 md:top-20 left-2"
        v-if="showRecommendation"
      >
        <template v-if="isApplicationTemplateLoading">
          <div class="flex py-10 items-center justify-center">
            <SmallLoading />
          </div>
        </template>
        <template v-else>
          <div class="flex justify-end pt-1 px-1">
            <XIcon
              class="w-5 h-5 text-brand-gray cursor-pointer"
              @click="showRecommendation = false"
            />
          </div>
          <div
            class="flex items-center py-2 px-2 cursor-pointer hover:bg-brand-light-gray address-suggestion"
            v-for="suggestion in getApplicationTemplateAddressSuggestions"
            :key="suggestion.label"
            @click="selectSuggestion(suggestion)"
          >
            <div class="flex flex-col">
              <p class="text-sm py-0.5">{{ suggestion.label.split(",")[0] }}</p>
              <p class="text-xs text-brand-mid-gray">
                {{ suggestion.city }}, {{ suggestion.stateCode }} {{ suggestion.postalCode }}
                {{ suggestion.countryCode }}
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </template>
  <template v-if="mode === 'view'"> </template>
  <template v-if="mode === 'form_edit'">
    <div class="flex flex-col w-full">
      <MultiLineInput
        :disabled="true"
        ref="input"
        :placeholder="`Street address,\nCity, State, Zip`"
        :value="`Street address,\nCity, State, Zip`"
      ></MultiLineInput>
      <TextDisplayEditToggle
        :helpText="field.help_text"
        :type="'field_subtext'"
        @input="updateHelpText"
        :disabled="field.editable === false"
      />
    </div>
  </template>
</template>
<script>
import _ from "lodash"
import { mapGetters } from "vuex"

import { XIcon } from "@heroicons/vue/outline"

import { APPLICATION_TEMPLATE_SEARCH_ADDRESS } from "@/store/types"

export default {
  components: {
    XIcon
  },
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  emits: ["update"],
  computed: {
    ...mapGetters(["getApplicationTemplateAddressSuggestions", "isApplicationTemplateLoading"]),
    isValid() {
      // TODO: Add address validation here
      // if (this.field.value.length >= 5)
      if (this.field.required && !this.field.value) {
        return false
      }
      return this.$refs.input.$refs.input.validity.valid
    }
  },
  data() {
    return {
      showRecommendation: false
    }
  },
  mounted() {
    if (this.field.name === "unit" && this.$route.query.p) {
      const property = JSON.parse(atob(this.$route.query.p))

      const { street, unit, city, state, zip } = property
      const newValue = `${street}${unit ? ` ${unit} ` : " "} ${city}, ${state} ${zip}`

      this.$emit("update", newValue)
    }
  },
  methods: {
    updateHelpText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.help_text = ev.target.value
    },
    updateValue(ev) {
      const value = ev.target.value
      this.$emit("update", value)

      if (value.length >= 3) {
        this.showRecommendation = true
      } else if (!value) {
        this.showRecommendation = false
      }

      if (this.showRecommendation) {
        this.searchAddress()
      }
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = "This field is required."
        } else {
          this.errorMessage = "Please enter a valid address."
        }
      } else {
        this.errorMessage = ""
      }
    },
    searchAddress: _.debounce(async function () {
      await this.$store.dispatch(APPLICATION_TEMPLATE_SEARCH_ADDRESS, {
        searchTerm: this.field.value
      })

      if (!this.getApplicationTemplateAddressSuggestions.length) {
        this.showRecommendation = false
      }
    }, 500),
    selectSuggestion(suggestion) {
      this.$emit("update", suggestion.label)
      this.showRecommendation = false
    }
  }
}
</script>
<style lang="scss" scoped></style>
